module.exports = __webpack_public_path__ + "img/ugly_or_beuty_holdfeny_kicsi.c8e00bc5.jpg";